import { renderToStaticMarkup } from "react-dom/server";
import { MODULES } from "../redux/appModule/appModuleSlice";
import {
  CoworkLogo,
  MakerslabIcon,
  EduspaceIcon,
  BloombergIcon,
} from "../MakersV2/Theme/Icons";

// Serialize an imported icon component's SVG to a favicon data URI, so the real
// module icons from Icons.jsx are reused for the browser tab (no separate image
// assets to maintain).
const iconFavicon = (IconComponent) => {
  const svg = renderToStaticMarkup(<IconComponent />);
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

// Per-module browser-tab branding: document title + favicon (the module's own icon).
export const MODULE_BRANDING = {
  [MODULES.COWORK]: { title: "CoWork", favicon: iconFavicon(CoworkLogo) },
  [MODULES.MAKERSLAB]: { title: "Makers Lab", favicon: iconFavicon(MakerslabIcon) },
  [MODULES.EDUSPACE]: { title: "Eduspace", favicon: iconFavicon(EduspaceIcon) },
  [MODULES.BLOOMBERG]: { title: "Bloomberg Lab", favicon: iconFavicon(BloombergIcon) },
};

// Apply the given module's title + favicon to the document. Safe to call on
// every module change.
export const applyModuleBranding = (moduleKey) => {
  const branding = MODULE_BRANDING[moduleKey] || MODULE_BRANDING[MODULES.COWORK];

  document.title = branding.title;

  // Replace any existing favicon link(s) with the module's icon.
  document.querySelectorAll("link[rel*='icon']").forEach((link) => link.remove());
  const link = document.createElement("link");
  link.rel = "icon";
  link.type = "image/svg+xml";
  link.href = branding.favicon;
  document.head.appendChild(link);
};
